import { FC } from "react";
import { BUTTON_LABELS } from "@miplatform/constants";
import { IDepartmentResponse } from "@miplatform/types";
import { mdiPencilOutline, mdiTrashCanOutline } from "@mdi/js";
import { ConfigCard } from "../../components";

export const ConfigDepartmentListCard: FC<IConfigDepartmentListCardProps> = ({
  item: department,
  onEdit = () => {},
  onDelete,
}) => {
  const { name, modifiedOn, id, createdOn } = department;

  const handleOnClick = () => {
    onEdit(id);
  };

  const actions = [
    {
      label: BUTTON_LABELS.EDIT,
      action: handleOnClick,
      icon: mdiPencilOutline,
    },
  ];

  if (onDelete) {
    actions.push({
      label: BUTTON_LABELS.DELETE,
      action: () => {
        onDelete(department);
      },
      icon: mdiTrashCanOutline,
    });
  }

  return (
    <ConfigCard
      title={name}
      modifiedOn={modifiedOn}
      menuActions={actions}
      createdOn={createdOn}
      onClick={handleOnClick}
    />
  );
};

interface IConfigDepartmentListCardProps {
  item: IDepartmentResponse;
  onEdit: (departmentId: string) => void;
  onDelete: (department: IDepartmentResponse) => void;
}
